import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { VraagboomEmptyResultaat } from '@models/vragenboom';
import { ComingDaysDateMapper } from '@components/lib/mappers/coming-days-date.mapper';
import { SharedData } from '@models/shareddata';
import { SharedDataService } from '@services/public_api';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-radiobutton-list-coming-days-summary',
  templateUrl: './radiobutton-list-coming-days-summary.component.html',
  styleUrls: ['./radiobutton-list-coming-days-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RadiobuttonListComingDaysSummaryComponent extends BaseSummaryControlDirective<VraagboomEmptyResultaat> implements OnInit {
  private _openingstijden: SharedData[];

  constructor(private _sharedDataService: SharedDataService) {
    super();
  }

  ngOnInit() {
    this._sharedDataService.getOpeningstijden().pipe(takeUntil(this.unsubscribe$))
      .subscribe((sd: SharedData[]) => {
        this._openingstijden = sd;
      });
  }

  getAnswer(): string {
    if (this.antwoordResultaat == null || this.antwoordResultaat.antwoorden == null || this.antwoordResultaat.antwoorden.length === 0) {
      return null;
    }

    return this.antwoordResultaat.antwoorden[0].titel;
  }

  transformToDate(titel: string): string {
    return ComingDaysDateMapper.transformComingDaysToDateString(new Date(), titel, this._openingstijden);
  }
}
